import { Component, computed, ElementRef, forwardRef, HostListener, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { FilterItem, SelectOption } from '../filter-component.model';
import { LocalizePipe } from "../../../pipes/LocalizePipe";

@Component({
  selector: 'app-custom-multiselect-component',
  imports: [CommonModule, FormsModule, LocalizePipe],
  templateUrl: './custom-multiselect-component.html',
  styleUrl: './custom-multiselect-component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomMultiselectComponent),
      multi: true
    }
  ]
})
export class CustomMultiselectComponent implements ControlValueAccessor {
  options = input<SelectOption[]>([]);
  filterItem = input<FilterItem>();
  searchTerm = signal<string>('');
  isOpen = signal<boolean>(false);
  value = signal<any[]>([]);
  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};
  private elementRef = inject(ElementRef);

  // vrátí záznamy, které nejsou vybrané (v this.value) a odpovídají případnému hledání
  availableOptions = computed(() => {
    const term = this.searchTerm().toLowerCase();
    return this.options().filter(opt => {
      const isSelected = this.value().includes(opt.value);
      const matchesSearch = opt.text.toLowerCase().includes(term);
      return !isSelected && matchesSearch;
    });
  });

  // seznam vybraných objektů (pro zobrazení tagů)
  selectedOptions = computed(() => {
    return this.options().filter(opt => this.value().includes(opt.value));
  });

  // otevření multiselectu
  onInputFocus() {
    this.isOpen.set(true);
    this.onTouched();
  }

  // výběr položky z dropdownu
  selectOption(option: SelectOption) {
    this.value.update(current => [...current, option.value]);
    this.searchTerm.set('');
    this.isOpen.set(false);
    this.onChange(this.value());
  }

  // odebrání tagu
  removeOption(optionValue: any) {
    this.value.update(current => current.filter(v => v !== optionValue));
    this.onChange(this.value());
  }

  // Angular nám posílá data z formuláře (např. při resetu nebo načtení)
  writeValue(obj: any): void {
    this.value.set(Array.isArray(obj) ? obj : []);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // zavření při kliku vedle a smazání případné hodnoty
  @HostListener('document:click', ['$event'])
  clickOutside(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen.set(false);
      this.searchTerm.set('');
    }
  }
}
